import { render, staticRenderFns } from "./MainLargeDialog.vue?vue&type=template&id=004d240c&scoped=true&"
import script from "./MainLargeDialog.vue?vue&type=script&lang=js&"
export * from "./MainLargeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d240c",
  null
  
)

export default component.exports